<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeletonForm" class="pa-3 mr-4">
      <v-row>
        <v-col cols="4">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" v-for="item in 2" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
        <v-spacer />
        <v-spacer />
        <v-col class="text-right">
          <v-skeleton-loader class="mx-auto" type="button" />
        </v-col>
      </v-row>
    </v-sheet>

    <div class="text-h4" v-show="!showSkeletonForm">Painel Administrativo</div>

    <v-form v-show="!showSkeletonForm">
      <v-row dense class="mt-4">
        <v-col cols="4">
          <v-datetime-picker
            label="Data início"
            v-model="datetimestart"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>
            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col cols="4">
          <v-datetime-picker
            label="Data fim"
            v-model="datetimeend"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>

            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>

            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col class="text-right">
          <v-btn color="bluePcm" dark @click="gerar">Buscar Dados</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="mx-2 mt-2" v-show="!showSkeletonForm" />

    <v-sheet v-show="!showResults && showSkeletonResults" class="pa-3 mr-4">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-if="showResults">
      <ResumedData />
      <DetailedData />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import { initialAndFinalDateTextInputReportForm } from '@/mixins/initialAndFinalDateTextInputReportForm'

import administrativePanelDataStore from '../_store'
import ResumedData from '../_components/ResumedData'
import DetailedData from '../_components/DetailedData'

export default {
  components: { ResumedData, DetailedData },
  mixins: [initialAndFinalDateTextInputReportForm],
  data: () => ({
    form: {
      dataHoraInicio: '',
      dataHoraFim: '',
    },
    showResults: false,
    showSkeletonForm: true,
    showSkeletonResults: false,
  }),

  async created() {
    registerVuexModule(this.$store, 'administrativePanelDataStore', administrativePanelDataStore)

    await this.listarFilas()

    this.showSkeletonForm = false
  },

  methods: {
    ...mapActions('administrativePanelDataStore', ['obtemDadosPainelAdministrativo', 'listarFilas']),

    async gerar() {
      this.showResults = false
      this.showSkeletonResults = true

      this.form.dataHoraInicio = moment(this.datetimestart).format('YYYY-MM-DD HH:mm:ss')
      this.form.dataHoraFim = moment(this.datetimeend).format('YYYY-MM-DD HH:mm:ss')

      await this.obtemDadosPainelAdministrativo(this.form)

      this.showResults = true
      this.showSkeletonResults = false
    },
  },
}
</script>
